import { render, staticRenderFns } from "./Pagenation.vue?vue&type=template&id=66f26940&"
import script from "./Pagenation.vue?vue&type=script&lang=js&"
export * from "./Pagenation.vue?vue&type=script&lang=js&"
import style0 from "./Pagenation.vue?vue&type=style&index=0&id=66f26940&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports